import FeedbackPage from './FeedbackPage.jsx';

export {
  FeedbackPage
};



// WEBPACK FOOTER //
// ./pages/feedback/index.js